import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children", "minimal", "disabled"];
import React, { Children } from 'react';
import { wrap } from '@unmapped/core/utils';
import clsx from 'clsx';
import baseStyles from "./styles.module.css.js";
import useStyleOverride from "../../hooks/useStyleOverride.js";
export var Button = wrap((_ref, ref) => {
  var {
      className,
      children,
      minimal,
      disabled = false
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyleOverride('controls/Button', baseStyles);
  return /*#__PURE__*/React.createElement("button", _extends({
    className: clsx(styles.Button, className, minimal && styles.minimal)
  }, rest, {
    disabled: disabled,
    ref: ref
  }), Children.map(children, child => typeof children === 'string' ? /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, child) : child));
}, 'Button');
export default Button;
//# sourceMappingURL=index.js.map